import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { CupomInterface } from '@/shared/models/cupom/cupom.interface';
import { CupomFilter } from '@/shared/models/cupom/cupom.filter';
import store from '@/store';
import queryUtil from '@/shared/utils/query.util';
import { instanciaAxios } from './base.service';
// Models

const cupons = 'cupons';

export default class CupomService {
  async buscarTodos(): Promise<any> {
    return await instanciaAxios.get(cupons)
      .then((response: any) => {
        const lista: Array<CupomInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorId(id: number): Promise<any> {
    return await instanciaAxios.get(`${cupons}/${id}`)
      .then((response: any) => {
        const cupom: CupomInterface = response.data;
        return cupom;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorFiltro(filtro: CupomFilter): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios.get(`${cupons}/pesquisa${query}`)
      .then((response: any) => {
        const lista: Array<CupomInterface> = response.data;
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async salvarAtualizar(body: CupomInterface): Promise<any> {
    if (body.id) {
      await instanciaAxios.put(`${cupons}/${body.id}`, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Cupom editado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    } else {
      await instanciaAxios.post(cupons, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Cupom cadastrado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    }
  }

  async excluir(cupom: CupomInterface): Promise<any> {
    await instanciaAxios.delete(`${cupons}/${cupom.id}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Cupom excluído com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }
}
